import Button from "@material-ui/core/esm/Button";
import clsx from 'clsx';
import React from 'react';
import Spinner from 'components/Spinner/Spinner';
import useStyles from './ButtonStyles';
export default function SecondaryButton({
  size,
  loading,
  className,
  children,
  disabled,
  onClick,
  outlined,
  startIcon,
  endIcon,
  ariaLabel
}) {
  const {
    secondaryButton,
    wrapper
  } = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: clsx({
      [wrapper]: loading
    })
  }, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    variant: outlined ? 'outlined' : undefined,
    className: clsx(className, secondaryButton),
    disabled: loading || disabled,
    onClick: onClick,
    size: size,
    startIcon: startIcon,
    endIcon: endIcon,
    "aria-label": ariaLabel
  }, children), loading && /*#__PURE__*/React.createElement(Spinner, {
    isButtonProgress: true
  }));
}
SecondaryButton.defaultProps = {
  disabled: false,
  loading: false,
  className: '',
  size: undefined,
  outlined: true,
  startIcon: undefined,
  endIcon: undefined,
  ariaLabel: undefined
};